import React, { useState, useEffect } from 'react';
import { TextField, Container, Box, IconButton, Typography } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'; // import add circle outline icon

interface Entry {
    credits: string;
    grade: string;
}

const GradeCalculator = () => {
    const [entries, setEntries] = useState<Entry[]>([{ credits: '', grade: '' }]);
    const [sum, setSum] = useState<number | null>(null);

    useEffect(() => {
        const gradeValues: { [key: string]: number } = { 'A': 3, 'B': 2.5, 'C': 2, 'D': 1.5, 'E': 1, '': 1 };
        let totalSum = 0;

        entries.forEach(entry => {
            const { credits, grade } = entry;
            if (credits && grade.toUpperCase() in gradeValues) {
                totalSum += parseInt(credits, 10) * gradeValues[grade.toUpperCase()];
            }
        });

        setSum(totalSum);
    }, [entries]);

    const handleInputChange = (index: number, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newEntries = [...entries];
        const { name, value } = event.target as HTMLInputElement; // Cast to HTMLInputElement

        if (name === 'credits' || name === 'grade') {
            if (name === 'grade') {
                if (value && !['A', 'B', 'C', 'D', 'E', ''].includes(value.toUpperCase())) return;
                newEntries[index][name as keyof Entry] = value.toUpperCase();
            } else {
                newEntries[index][name as keyof Entry] = value;
            }
            setEntries(newEntries);
        }
    };

    const addEntry = () => {
        setEntries([...entries, { credits: '', grade: '' }]);
    };

    const removeEntry = (index: number) => {
        const newEntries = entries.filter((_, i) => i !== index);
        setEntries(newEntries);
    };

    return (
        <Container maxWidth="sm">
            <Box mb={2} display="flex" flexDirection="column" alignItems="center" justifyContent="center" mt={4} style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    Vážený počet kreditů: {sum ?? 0}
                </Typography>
                <Typography variant="subtitle2">
                    (Nepište žádnou známku, pokud se jedná o zápočet)
                </Typography>
                {entries.map((entry, index) => (
                    <Box key={index} display="flex" justifyContent="center" alignItems="center" gap={2}>
                        <Typography variant="body2" component="span">
                            {index + 1}.
                        </Typography>
                        <TextField
                            label="Kredity"
                            name="credits"
                            value={entry.credits}
                            onChange={(e) => handleInputChange(index, e)}
                            margin="normal"
                            type="number"
                            size="small"
                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                        />
                        <TextField
                            label="Známka"
                            name="grade"
                            value={entry.grade}
                            onChange={(e) => handleInputChange(index, e)}
                            margin="normal"
                            size="small"
                            inputProps={{ maxLength: 1 }}
                        />
                        <IconButton color="error" onClick={() => removeEntry(index)}>
                            <ClearIcon />
                        </IconButton>
                    </Box>
                ))}
                <Box mb={1}>
                    <IconButton color="primary" onClick={addEntry}>
                        <AddCircleOutlineIcon />
                    </IconButton>
                </Box>
            </Box>
        </Container>
    );
};

export default GradeCalculator;
